import styled from 'styled-components'

import { TradeSettingsHeader } from './trade-settings-header'
import { TradeSettingsPresetForm } from './trade-settings-preset-form'

import type { TradeSettingsFormProps } from './trade-settings-preset-form'

type TradeSettingsProps = {
  onClose: () => void
} & TradeSettingsFormProps

export const TradeSettings: React.FC<TradeSettingsProps> = ({
  onClose,
  ...formProps
}) => {
  return (
    <Root>
      <TradeSettingsHeader onClose={onClose} />
      <TradeSettingsPresetForm {...formProps} onSaved={onClose} />
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  background: var(--background-2);

  display: grid;
  grid-template-rows: auto auto;
  align-content: start;
  grid-template-rows: auto minmax(0, 1fr);
  border: 0.6px solid var(--backgroundA-3);

  border-radius: 12px;
  max-height: 100%;
`
